import { BasePropertyApi } from './base-api.interface';
import { getTextHighlightColor } from './get-common-properties';
import { updateTextHighlightColor } from './update-common-properties';

export const textHighlightColorAPI: BasePropertyApi = {
  get: getTextHighlightColor,
  update: updateTextHighlightColor,
};
